/**
 * Backtick-quote a string for safe interpolation into a DQL field path.
 *
 * DQL parameterized queries (`:args`) only work for values, not identifiers,
 * so user-supplied field names must be interpolated into the query string.
 * This escapes them by doubling embedded backticks and wrapping in backticks,
 * which is the DQL parser's quoting syntax for identifiers.
 *
 * This only covers identifiers. Values must still use `:args`.
 */
export const escapeDqlIdentifier = (name: string) =>
  `\`${name.replace(/`/g, '``')}\``
